import { HttpErrorResponse } from '@angular/common/http';

export function parseHttpErrorBody(error: HttpErrorResponse): any {
  const raw = error.error;
  if (raw == null) {
    return null;
  }
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return { message: raw };
    }
  }
  return raw;
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/forms/parse-http-error-body.ts